import { JsonPipe } from '@angular/common'
import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatIconModule } from '@angular/material/icon'
import { ErrorCenterService } from '../../services/error-center.service'

/**
 * Fehlerzentrale als Dialog — geöffnet ausschliesslich über die {@link ErrorCenterButtonComponent}
 * in der Toolbar, und die zeigt sich nur SaniUp-Mitarbeitenden. Sie ist ein internes
 * Diagnosewerkzeug: die Fehler stehen roh als JSON darin.
 */
@Component({
  selector: 'lib-error-center',
  imports: [JsonPipe, MatDialogModule, MatExpansionModule, MatIconModule, MatButtonModule],
  templateUrl: './error-center.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './error-center.component.scss',
})
export class ErrorCenterComponent {
  readonly errorCenterService = inject(ErrorCenterService)

  /**
   * Kurzfassung für die Panel-Zeile. Nicht nur `instanceof Error` prüfen: `HttpErrorResponse`
   * erfüllt die `Error`-Schnittstelle, erbt aber von `HttpResponseBase` — der häufigste Fehler
   * hier wäre sonst ausgerechnet der, der als „Unbekannter Fehler" durchfällt.
   */
  message(error: unknown) {
    if (error instanceof Error) return error.message
    if (typeof error === 'object' && error !== null && 'message' in error) return String(error.message)
    return 'Unbekannter Fehler'
  }
}
